export const FONT_SIZE = {
	SMALL: "SMALL",
	STANDARD: "STANDARD",
	LARGE: "LARGE",
};
